import { useState } from "react";
import { Field, FormResult, useFormSubmit, emailOk, SubmitButton, Honeypot } from "./FormKit";

const TOOLS = ["Alientech KESS3", "Autotuner", "Dimsport New Genius", "Dimsport New Trasdata", "Magic Motorsport FLEX", "CMD Flashtec", "Not sure yet"];
const BUSINESS = ["Existing garage / workshop", "Mobile technician", "Starting a new business", "Leaving the Armed Forces", "Other"];

const validate = (v) => {
  const e = {};
  if ((v.name || "").trim().length < 2) e.name = "Please enter your name";
  if (!emailOk(v.email)) e.email = "Please enter a valid email address";
  if (!/^[0-9 +()-]{6,40}$/.test(v.phone || "")) e.phone = "A phone number helps us call you back";
  if ((v.location || "").trim().length < 2) e.location = "Where will you operate?";
  if (!v.business_type) e.business_type = "Please choose one";
  if (!v.consent) e.consent = "Please confirm we can contact you";
  return e;
};

export function DealerForm() {
  const [v, setV] = useState({ name: "", email: "", phone: "", company: "", location: "", business_type: "", experience: "", tools_interest: [], message: "", consent: false, website: "" });
  const [state, submit] = useFormSubmit("/forms/dealer", validate);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const toggleTool = (t) => setV({ ...v, tools_interest: v.tools_interest.includes(t) ? v.tools_interest.filter((x) => x !== t) : [...v.tools_interest, t] });
  if (state.status === "success") return <FormResult {...state} testPrefix="dealer-form" />;
  const err = state.errors;
  return (
    <form noValidate onSubmit={(e) => { e.preventDefault(); submit(v); }} className="relative space-y-6" data-testid="dealer-form">
      <Honeypot value={v.website} onChange={(x) => setV({ ...v, website: x })} />
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Full name *" id="dealer-name" error={err.name}><input id="dealer-name" className="field" value={v.name} onChange={set("name")} autoComplete="name" data-testid="dealer-name-input" /></Field>
        <Field label="Business name" id="dealer-company"><input id="dealer-company" className="field" value={v.company} onChange={set("company")} autoComplete="organization" data-testid="dealer-company-input" /></Field>
        <Field label="Email *" id="dealer-email" error={err.email}><input id="dealer-email" type="email" className="field" value={v.email} onChange={set("email")} autoComplete="email" data-testid="dealer-email-input" /></Field>
        <Field label="Phone *" id="dealer-phone" error={err.phone}><input id="dealer-phone" type="tel" className="field" value={v.phone} onChange={set("phone")} autoComplete="tel" data-testid="dealer-phone-input" /></Field>
        <Field label="Town / area *" id="dealer-location" error={err.location}><input id="dealer-location" className="field" value={v.location} onChange={set("location")} data-testid="dealer-location-input" /></Field>
        <Field label="Your situation *" id="dealer-business" error={err.business_type}>
          <select id="dealer-business" className="field" value={v.business_type} onChange={set("business_type")} data-testid="dealer-business-select">
            <option value="">Select…</option>
            {BUSINESS.map((b) => <option key={b}>{b}</option>)}
          </select>
        </Field>
        <Field label="Remapping experience" id="dealer-experience">
          <select id="dealer-experience" className="field" value={v.experience} onChange={set("experience")} data-testid="dealer-experience-select">
            <option value="">Select…</option>
            {["None — new to remapping", "Some — used tools before", "Experienced — currently remapping"].map((b) => <option key={b}>{b}</option>)}
          </select>
        </Field>
      </div>
      <fieldset>
        <legend className="label">Tools you're interested in</legend>
        <div className="flex flex-wrap gap-2">
          {TOOLS.map((t) => {
            const on = v.tools_interest.includes(t);
            return (
              <button type="button" key={t} onClick={() => toggleTool(t)} aria-pressed={on} data-testid={`dealer-tool-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`border px-3 py-2 text-xs font-medium transition-colors ${on ? "border-[color:var(--ice)] bg-[color:var(--ice)]/10 text-[color:var(--ice)]" : "border-[color:var(--line-2)] text-slate-300 hover:border-slate-400"}`}>{t}</button>
            );
          })}
        </div>
      </fieldset>
      <Field label="Anything else?" id="dealer-message"><textarea id="dealer-message" rows={4} className="field" value={v.message} onChange={set("message")} data-testid="dealer-message-input" /></Field>
      <label className="flex items-start gap-3 text-sm text-slate-300">
        <input type="checkbox" checked={v.consent} onChange={(e) => setV({ ...v, consent: e.target.checked })} className="mt-1 h-4 w-4 accent-[#7dd3fc]" data-testid="dealer-consent-checkbox" />
        <span>I agree to Jorvik Tuning contacting me about this application. See our <a className="text-[color:var(--ice)] underline" href="/privacy-policy">privacy policy</a>.</span>
      </label>
      {err.consent && <p className="text-xs text-red-400" data-testid="dealer-consent-error">{err.consent}</p>}
      <FormResult {...state} testPrefix="dealer-form" />
      <SubmitButton busy={state.status === "busy"} testId="dealer-submit-button">Send application</SubmitButton>
    </form>
  );
}
